/*

You can now create a spinner using any of the variants below:

$("#el").spin(); // Produces default Spinner using the text color of #el.
$("#el").spin({ size: 'small' }); // Produces a 'small' Spinner using the text color of #el.
$("#el").spin({ size: 'large', color: 'white'}); // Produces a 'large' Spinner in white (or any valid CSS color).

$("#el").stopSpinner(); // Kills the spinner.

*/
(function () {
  const SPINNER_CLASS = 'spinner';

  $.fn.stopSpinner = function () {
    return this.each(function () {
      const $this = $(this);

      function stop() {
        $this.css('position', '');

        const $spinner = $this.find(`.${SPINNER_CLASS}`);
        $spinner.remove();
      }

      stop();
    });
  };

  $.fn.spin = function (opts) {
    const options = $.extend({}, $.fn.spin.defaults, opts);

    return this.each(function () {
      const $this = $(this);

      function buildSpinner() {
        const $spinner = $('<div class="loading-component-container" />').addClass(SPINNER_CLASS);
        if (options.overlay) {
          $spinner.addClass('loading-overlay');
        }

        const $loadingComponent = $('<div class="loading-component" />').appendTo($spinner);

        if (options.size) {
          $loadingComponent.addClass(options.size);
        }

        const wing = $('<div class="rect" />');
        const wingCount = options.size == 'small' ? 3 : 5;

        for (let i = 0; i < wingCount; i++) {
          const $clone = wing.clone().addClass(`rect${i + 1}`);

          if (options.color) {
            $clone.css('background-color', options.color);
          }

          $loadingComponent.append($clone);
        }

        $this.append($spinner);

        $loadingComponent.css({
          marginTop: -($loadingComponent.innerHeight() / 2),
          top: '50%',
          position: 'absolute',
        });
      }

      function start() {
        if ($this.css('position') === 'static') {
          $this.css('position', 'relative');
        }

        buildSpinner();
      }

      start();
    });
  };

  $.fn.spin.defaults = {
    size: null,
    color: null,
    overlay: true,
  };
}());



// WEBPACK FOOTER //
// ./src/components/legacy/plugins/jquery.spin.js